/* DAYVEE Routine-Quiz (Eigenbau). Logik und Tags wie im bisherigen Revenue-Hunt-Quiz. Antworten bleiben im Browser. */
(function () {
  'use strict';

  var ARROW_BACK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var WARN_ICON = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.2 21 19H3L12 3.2z"/><path d="M12 9v4.5"/><circle cx="12" cy="16.4" r=".6" fill="currentColor"/></svg>';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function hasAll(tags, list) {
    return !list || list.every(function (t) { return tags.indexOf(t) !== -1; });
  }

  function hasAny(tags, list) {
    return !list || list.some(function (t) { return tags.indexOf(t) !== -1; });
  }

  function initQuiz(root) {
    if (root.__dyqReady) return;
    root.__dyqReady = true;

    var cfg;
    try {
      cfg = JSON.parse(root.querySelector('[data-dyq-config]').textContent);
    } catch (error) {
      console.error('DAYVEE Quiz: Konfiguration konnte nicht gelesen werden.', error);
      return;
    }

    /* In die rechte Spalte von "Dayvee Schritte + Quiz" einhängen. */
    var slot = document.querySelector('.dyv-routine-flow__quiz');
    if (slot && !slot.contains(root) && !slot.querySelector('[data-dayvee-quiz], .shopify-app-block')) {
      slot.appendChild(root);
    }
    root.classList.add('is-mounted');

    var stage = root.querySelector('[data-dyq-stage]');
    var texts = cfg.texts || {};
    var trackUrl = (root.getAttribute('data-track-url') || '').trim();
    var Q = {};
    cfg.questions.forEach(function (q) { Q[q.id] = q; });

    var state;
    function reset() {
      state = { answers: {}, pos: 0, view: 'question', started: false, reported: {}, lastUrl: '', lock: 0, swap: 0, interacted: false };
    }
    reset();

    /* Anonymer Zähler, nur mit track_url. */
    function track(event, extra) {
      if (!trackUrl) return;
      var payload = { e: event };
      if (extra) Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
      var body = JSON.stringify(payload);
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(trackUrl, new Blob([body], { type: 'text/plain' }));
        } else {
          fetch(trackUrl, { method: 'POST', body: body, keepalive: true, credentials: 'omit', mode: 'no-cors' });
        }
      } catch (error) {}
    }

    function tagOf(id) {
      var i = state.answers[id];
      return i == null ? null : Q[id].options[i].tag;
    }

    function visible(q, tags) {
      if (!q.showIf) return true;
      return hasAll(tags, q.showIf.all) && hasAny(tags, q.showIf.any);
    }

    function resolve(id, tags) {
      while (id && id !== 'end' && Q[id] && !visible(Q[id], tags)) {
        id = typeof Q[id].next === 'string' ? Q[id].next : null;
      }
      return id;
    }

    /* Fragen auf dem aktuellen Weg bis zur ersten unbeantworteten. */
    function computePath() {
      var path = [];
      var tags = [];
      var id = resolve(cfg.start, tags);
      var complete = false;
      var guard = 0;
      while (id && id !== 'end' && Q[id] && guard++ < 50) {
        path.push(id);
        var tag = tagOf(id);
        if (!tag) break;
        tags.push(tag);
        var next = Q[id].next;
        next = typeof next === 'string' ? next : (next && next[tag]);
        id = resolve(next, tags);
        if (id === 'end') complete = true;
      }
      return { path: path, tags: tags, complete: complete };
    }

    function totalQuestions(tags) {
      var total = (cfg.progress && cfg.progress.base) || cfg.questions.length;
      cfg.questions.forEach(function (q) {
        if (q.showIf && visible(q, tags)) total += 1;
      });
      return total;
    }

    function resultFor(tags) {
      for (var i = 0; i < cfg.results.length; i += 1) {
        if (hasAll(tags, cfg.results[i].all)) return cfg.results[i];
      }
      return null;
    }

    function keepInView() {
      var rect = root.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /* Alte und neue Frage gleiten gleichzeitig (vorwärts nach links, zurück nach rechts). */
    function show(node, dir) {
      var olds = Array.prototype.slice.call(stage.children);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!olds.length || reduce || !dir) {
        stage.innerHTML = '';
        stage.appendChild(node);
        return;
      }
      var startH = stage.offsetHeight;
      var tops = olds.map(function (old) { return old.offsetTop; });
      var cs = window.getComputedStyle(stage);
      stage.style.transition = '';
      stage.style.height = '';
      olds.forEach(function (old, i) {
        old.classList.remove('is-from-left', 'is-from-right', 'is-leaving-left', 'is-leaving-right');
        old.style.position = 'absolute';
        old.style.top = tops[i] + 'px';
        old.style.left = cs.paddingLeft;
        old.style.right = cs.paddingRight;
        old.style.pointerEvents = 'none';
        old.setAttribute('aria-hidden', 'true');
        old.inert = true;
        old.classList.add(dir === 'back' ? 'is-leaving-right' : 'is-leaving-left');
        window.setTimeout(function () { if (old.parentNode === stage) stage.removeChild(old); }, 640);
      });
      node.classList.add(dir === 'back' ? 'is-from-left' : 'is-from-right');
      stage.appendChild(node);
      var endH = stage.offsetHeight;
      if (Math.abs(endH - startH) > 2) {
        stage.style.height = startH + 'px';
        void stage.offsetHeight;
        stage.style.transition = 'height .6s cubic-bezier(.25, .8, .25, 1)';
        stage.style.height = endH + 'px';
        var token = ++state.swap;
        window.setTimeout(function () {
          if (token !== state.swap) return;
          stage.style.height = '';
          stage.style.transition = '';
        }, 640);
      }
    }

    function focusHeading(scroll) {
      var heading = stage.lastElementChild && stage.lastElementChild.querySelector('[data-dyq-heading]');
      if (heading && state.interacted) {
        try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
      }
      if (scroll) keepInView();
    }

    function arrow(kind, label, disabled, onClick) {
      var button = el('button', 'dyq__arrow dyq__arrow--' + kind);
      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.innerHTML = kind === 'back' ? ARROW_BACK : ARROW_NEXT;
      button.disabled = !!disabled;
      button.addEventListener('click', onClick);
      return button;
    }

    function renderQuestion(scroll, dir) {
      var info = computePath();
      if (state.pos > info.path.length - 1) state.pos = info.path.length - 1;
      var id = info.path[state.pos];
      var q = Q[id];
      var selected = state.answers[id];
      var percent = Math.min(100, Math.round((state.pos / totalQuestions(info.tags)) * 100));

      var wrap = el('div', 'dyq__screen dyq__screen--question');
      var head = el('div', 'dyq__head');
      var title = el('h3', 'dyq__title', q.title);
      title.id = 'dyq-title-' + id;
      title.tabIndex = -1;
      title.setAttribute('data-dyq-heading', '');
      head.appendChild(title);
      if (q.text) head.appendChild(el('p', 'dyq__text', q.text));
      wrap.appendChild(head);

      var list = el('div', 'dyq__choices');
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-labelledby', title.id);
      q.options.forEach(function (option, index) {
        var button = el('button', 'dyq__choice' + (selected === index ? ' is-selected' : ''));
        button.type = 'button';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', selected === index ? 'true' : 'false');
        button.appendChild(el('span', 'dyq__radio'));
        button.appendChild(el('span', 'dyq__label', option.label));
        button.addEventListener('click', function () { choose(id, index, button, list); });
        list.appendChild(button);
      });
      wrap.appendChild(list);

      var nav = el('div', 'dyq__nav');
      nav.appendChild(arrow('back', texts.back || 'Zurück', state.pos === 0, goBack));
      var progress = el('div', 'dyq__progress');
      progress.appendChild(el('div', 'dyq__progress-text', (texts.progress || '{percent}%').replace('{percent}', percent)));
      var bar = el('div', 'dyq__bar');
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '100');
      bar.setAttribute('aria-valuenow', String(percent));
      var fill = el('div', 'dyq__bar-fill');
      fill.style.width = percent + '%';
      bar.appendChild(fill);
      progress.appendChild(bar);
      nav.appendChild(progress);
      nav.appendChild(arrow('next', texts.next || 'Weiter', selected == null, goNext));
      wrap.appendChild(nav);

      show(wrap, dir);

      var step = /^F2/.test(id) ? 'F2' : id;
      if (!state.reported[step]) {
        state.reported[step] = true;
        track('q', { id: step });
      }
      window.setTimeout(function () { focusHeading(scroll); }, dir ? 200 : 0);
    }

    function renderSafety() {
      var wrap = el('div', 'dyq__screen dyq__screen--safety');
      var kicker = el('div', 'dyq__safety-kicker');
      var icon = el('span', 'dyq__safety-icon');
      icon.innerHTML = WARN_ICON;
      kicker.appendChild(icon);
      kicker.appendChild(el('span', 'dyq__safety-kicker-text', texts.safetyKicker));
      wrap.appendChild(kicker);
      var title = el('h3', 'dyq__safety-title', texts.safetyTitle);
      title.tabIndex = -1;
      title.setAttribute('data-dyq-heading', '');
      wrap.appendChild(title);
      wrap.appendChild(el('p', 'dyq__safety-lead', texts.safetyLead));
      var box = el('div', 'dyq__safety-box');
      box.appendChild(el('strong', 'dyq__safety-box-title', texts.safetyBoxTitle));
      box.appendChild(el('p', 'dyq__safety-box-text', texts.safetyBoxText));
      wrap.appendChild(box);
      wrap.appendChild(el('p', 'dyq__safety-text', texts.safetyText));
      var confirm = el('button', 'dyq__button', texts.safetyConfirm);
      confirm.type = 'button';
      confirm.addEventListener('click', function () {
        track('safety_confirmed');
        openResult(computePath().tags);
      });
      wrap.appendChild(confirm);
      var back = el('button', 'dyq__link', texts.safetyBack);
      back.type = 'button';
      back.addEventListener('click', function () {
        state.view = 'question';
        renderQuestion(true, 'back');
      });
      wrap.appendChild(back);
      show(wrap, 'next');
      window.setTimeout(function () { focusHeading(true); }, 200);
    }

    function renderDone() {
      var wrap = el('div', 'dyq__screen dyq__screen--done');
      var title = el('h3', 'dyq__title', texts.doneTitle);
      title.tabIndex = -1;
      title.setAttribute('data-dyq-heading', '');
      wrap.appendChild(title);
      wrap.appendChild(el('p', 'dyq__text', texts.doneText));
      var actions = el('div', 'dyq__done-actions');
      var reopen = el('button', 'dyq__button', texts.doneReopen);
      reopen.type = 'button';
      reopen.addEventListener('click', function () { if (state.lastUrl) openUrl(state.lastUrl, null, []); });
      actions.appendChild(reopen);
      var retake = el('button', 'dyq__button dyq__button--ghost', texts.doneRetake);
      retake.type = 'button';
      retake.addEventListener('click', function () {
        reset();
        state.interacted = true;
        renderQuestion(true, 'next');
      });
      actions.appendChild(retake);
      wrap.appendChild(actions);
      show(wrap, 'next');
      window.setTimeout(function () { focusHeading(false); }, 200);
    }

    function choose(id, index, button, list) {
      state.interacted = true;
      if (!state.started) {
        state.started = true;
        track('start');
      }
      state.answers[id] = index;
      list.querySelectorAll('.dyq__choice').forEach(function (node) {
        var active = node === button;
        node.classList.toggle('is-selected', active);
        node.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      /* Antworten abseits des neuen Wegs verwerfen. */
      var onPath = computePath().path;
      Object.keys(state.answers).forEach(function (key) {
        if (onPath.indexOf(key) === -1) delete state.answers[key];
      });
      var token = ++state.lock;
      window.setTimeout(function () {
        if (token === state.lock) goNext();
      }, 260);
    }

    function goBack() {
      state.lock++;
      state.interacted = true;
      if (state.pos > 0) {
        state.pos -= 1;
        renderQuestion(true, 'back');
      }
    }

    function goNext() {
      state.lock++;
      var info = computePath();
      state.interacted = true;
      if (state.pos < info.path.length - 1) {
        state.pos += 1;
        renderQuestion(true, 'next');
        return;
      }
      if (info.complete) finish(info.tags);
    }

    function finish(tags) {
      var safety = cfg.safetyTags || [];
      if (tags.some(function (t) { return safety.indexOf(t) !== -1; })) {
        state.view = 'safety';
        track('safety_shown');
        renderSafety();
        return;
      }
      openResult(tags);
    }

    function openUrl(url, key, tags) {
      if (typeof window.openDayveeRoutineModal === 'function') {
        window.openDayveeRoutineModal(url);
        return;
      }
      if (document.querySelector('[data-dayvee-routine-modal]')) {
        window.dispatchEvent(new CustomEvent('DAYVEE_OPEN_ROUTINE_MODAL', {
          detail: { type: 'DAYVEE_OPEN_ROUTINE_MODAL', result: key, url: url, tags: tags, source: 'dayvee-quiz' }
        }));
        return;
      }
      window.location.href = url;
    }

    function openResult(tags) {
      var result = resultFor(tags);
      if (!result) {
        console.error('DAYVEE Quiz: Ergebnisseite konnte nicht bestimmt werden.', tags);
        return;
      }
      var url = result.path + '?tags=' + encodeURIComponent(tags.join(','));
      state.lastUrl = url;
      state.view = 'done';
      track('complete', { r: result.key });
      renderDone();
      openUrl(url, result.key, tags);
    }

    /* Testhilfe: Ergebnis-URL für eine Antwortfolge berechnen. */
    root.dayveeQuizSimulate = function (tagList) {
      reset();
      tagList.forEach(function (tag) {
        var info = computePath();
        var id = info.path[info.path.length - 1];
        var idx = Q[id].options.findIndex(function (o) { return o.tag === tag; });
        if (idx === -1) throw new Error('Tag ' + tag + ' passt nicht zu Frage ' + id);
        state.answers[id] = idx;
      });
      var done = computePath();
      var res = resultFor(done.tags);
      var out = { complete: done.complete, path: done.path, tags: done.tags, url: res ? res.path + '?tags=' + encodeURIComponent(done.tags.join(',')) : null };
      reset();
      renderQuestion(false);
      return out;
    };

    renderQuestion(false);
  }

  function boot() {
    document.querySelectorAll('[data-dayvee-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();